"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conferenceClick = void 0;
var util_1 = require("./util");
exports.conferenceClick = (0, util_1.makeConferenceMapping)('conf-click');
